import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from 'Components/UI/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FacetLogoPrimary from 'Icons/Brand/FacetLogoPrimary';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(4, 0),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    alignSelf: 'flex-start',
  },
  facetIcon: {
    width: 155,
    height: '100%',
    marginBottom: theme.spacing(6),
    alignSelf: 'flex-start',
  },
  subTitle: {
    marginTop: theme.spacing(4),
  },
});

const AuthenticationHeader = ({
  className,
  classes,
  title,
  subtitle,
  color,
  showIcon,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {showIcon && (
        <FacetLogoPrimary className={classes.facetIcon} />
      )}
      <Typography
        variant={'h1'}
        color={color}
        weight={'bold'}
        className={classes.title}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant={'h5'}
          color={color}
          weight={'light'}
          align={'left'}
          className={classes.subTitle}
        >
          {subtitle}
        </Typography>)
      }
    </Box>
  );
};

AuthenticationHeader.defaultProps = {
  className: '',
  color: 'primary',
  subtitle: null,
  showIcon: false,
};

AuthenticationHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default withStyles(styles)(AuthenticationHeader);
